/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxcatalog_Retry1Inputs */

const en_us2_sandboxcatalog_retry1 = /** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const es_es2_sandboxcatalog_retry1 = /** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentar`)
};

const ru_sandboxcatalog_retry1 = /** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробуйте ещё раз`)
};

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const id_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const ms_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const da_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const de_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const es_mx2_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const fil_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const fr_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const it_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const hu_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const nl_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const no_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const pl_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const pt_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const pt_br2_sandboxcatalog_retry1 = pt_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const ro_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const fi_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const sv_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const vi_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const tr_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const cs_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const bg_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const uk_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const ar_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const hi_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const th_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const ja_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const zh_cn2_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const zh_hant1_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/** @type {(inputs: Sandboxcatalog_Retry1Inputs) => LocalizedString} */
const ko_sandboxcatalog_retry1 = en_us2_sandboxcatalog_retry1;

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Sandboxcatalog_Retry1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxcatalog_retry1 = /** @type {((inputs?: Sandboxcatalog_Retry1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxcatalog_Retry1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxcatalog_retry1(inputs)
	if (locale === "ms") return ms_sandboxcatalog_retry1(inputs)
	if (locale === "da") return da_sandboxcatalog_retry1(inputs)
	if (locale === "de") return de_sandboxcatalog_retry1(inputs)
	if (locale === "en-US") return en_us2_sandboxcatalog_retry1(inputs)
	if (locale === "es-ES") return es_es2_sandboxcatalog_retry1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxcatalog_retry1(inputs)
	if (locale === "fil") return fil_sandboxcatalog_retry1(inputs)
	if (locale === "fr") return fr_sandboxcatalog_retry1(inputs)
	if (locale === "it") return it_sandboxcatalog_retry1(inputs)
	if (locale === "hu") return hu_sandboxcatalog_retry1(inputs)
	if (locale === "nl") return nl_sandboxcatalog_retry1(inputs)
	if (locale === "no") return no_sandboxcatalog_retry1(inputs)
	if (locale === "pl") return pl_sandboxcatalog_retry1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxcatalog_retry1(inputs)
	if (locale === "pt") return pt_sandboxcatalog_retry1(inputs)
	if (locale === "ro") return ro_sandboxcatalog_retry1(inputs)
	if (locale === "fi") return fi_sandboxcatalog_retry1(inputs)
	if (locale === "sv") return sv_sandboxcatalog_retry1(inputs)
	if (locale === "vi") return vi_sandboxcatalog_retry1(inputs)
	if (locale === "tr") return tr_sandboxcatalog_retry1(inputs)
	if (locale === "cs") return cs_sandboxcatalog_retry1(inputs)
	if (locale === "bg") return bg_sandboxcatalog_retry1(inputs)
	if (locale === "ru") return ru_sandboxcatalog_retry1(inputs)
	if (locale === "uk") return uk_sandboxcatalog_retry1(inputs)
	if (locale === "ar") return ar_sandboxcatalog_retry1(inputs)
	if (locale === "hi") return hi_sandboxcatalog_retry1(inputs)
	if (locale === "th") return th_sandboxcatalog_retry1(inputs)
	if (locale === "ja") return ja_sandboxcatalog_retry1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxcatalog_retry1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxcatalog_retry1(inputs)
	return ko_sandboxcatalog_retry1(inputs)
});
export { sandboxcatalog_retry1 as "sandboxCatalog.retry" }